import { gql } from "@apollo/client";
import { UserApplication, UserApplicationSessionEventType } from "../types";

export const INSERT_USER_APPLICATION_SESSION_EVENT = gql`
  mutation InsertUserApplicationSessionEvent(
    $application: user_application_enum!
    $itemId: uuid!
    $eventType: user_application_session_event_type_enum!
  ) {
    insertUserApplicationSessionEvent: insert_user_application_session_event_one(
      object: { application: $application, item_id: $itemId, event_type: $eventType }
    ) {
      id
      createdAt: created_at
    }
  }
`;

export interface InsertUserApplicationSessionEventData {
  insertUserApplicationSessionEvent: {
    id: string;
    createdAt: string;
  };
}

export interface InsertUserApplicationSessionEventVars {
  application: UserApplication;
  itemId: string;
  eventType: UserApplicationSessionEventType;
}
